import { render, staticRenderFns } from "./UpCourse.vue?vue&type=template&id=18a37e55&scoped=true&"
import script from "./UpCourse.vue?vue&type=script&lang=js&"
export * from "./UpCourse.vue?vue&type=script&lang=js&"
import style0 from "./UpCourse.vue?vue&type=style&index=0&id=18a37e55&prod&lang=scss&scoped=true&"
import style1 from "./UpCourse.vue?vue&type=style&index=1&id=18a37e55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a37e55",
  null
  
)

export default component.exports